export default __webpack_public_path__ + "static/media/CSIO_logo.39daf90e.png";